<template>
  <v-container fluid class="board-wrapper">
    <v-slide-y-transition>  
        <v-layout row >
             <v-progress-circular
                v-if="loadingBoard || loadingLists"
                :size="50"
                color="primary"
                indeterminate
              ></v-progress-circular>
                <v-flex xs12>
                   <v-alert
                 v-if="listsError || boardsError|| cardsError"
                border="right"
                colored-border
                type="error"
                elevation="2"
              >
               You do not have permission to access this page.
              </v-alert>
              <v-flex class="board-head">
                  <h2 v-if="board" class="board-title">{{board.name}}</h2>
                  <a class="board-menu"  @click.stop="drawer = !drawer"><i class="fas fa-ellipsis-h"></i>Show Menu</a>
              </v-flex>
                   
                </v-flex>
                <div class="board-canvas">
                  <div class="board-main-content">
                    <div id="board">

                 
                    <div v-if="!loadingLists" sm3 v-for="list in lists" :key="list._id" pa-2 class="list-wrapper">
                      <v-card @dragover="setDroppingLists($event, list)" :class="{'green lighten-4': droppingList == list }">
                        <v-card-title primary-title class="board-title">
                          <div class="headline list-header">{{list.name}}<v-btn class="delete" icon @click="removeList($event,{_id: list._id})"><i class="far fa-trash-alt"></i></v-btn></div>
                          </v-card-title>
                        <v-col v-for="card in cardsByListId[list._id]" :key="card._id" cols="12" >
                        <v-card draggable="true" @dragstart="startDraggingCard(card)" @dragend="dropCard()" class="list-card">
                            <div class="d-flex flex-no-wrap justify-space-between">
                              <div>
                                <v-card-title
                                  class="headline"
                                  v-text="card.title"
                                ></v-card-title>
                              </div>
                            </div>
                          </v-card>
                      </v-col>
                      
                        <v-card-actions>
                              <CreateCard :listId="list._id" :boardId="$route.params.id" :createActivity="createActivity" :user="user.user"/>
                        </v-card-actions>
                      </v-card>
                  
                  </div>   
                 <div class="create-list">
                  <v-card >
                    <v-card-title class="board-title">
                      <div class="headline board-title">Add List</div>
                    </v-card-title>
                    <v-form
                      @submit.prevent="createList"
                      v-model="validList"
                      @keydown.prevent.enter
                      v-if="!creatingList">
                        <v-text-field
                          v-model="list.name"
                          label="Name"
                          :rules="notEmptyRules"
                          type="text"
                          required
                        />
                        <v-btn type="submit" icon :disabled="!validList" color="primary"><i class="fas fa-plus"></i> Create</v-btn>
                    </v-form>
                  </v-card>
                  </div>
                </div>
                </div>
                      </div>
                
        </v-layout>
    </v-slide-y-transition>
    <v-navigation-drawer
      fixed
      v-model="drawer"
      right
      style="margin-top: 65px;"
    >
      <template v-slot:prepend>
        <v-list-item two-line>

          <v-list-item-content>
            <v-list-item-title>Menu  <a @click.stop="drawer = !drawer"><i class="fas fa-times"></i></a></v-list-item-title>
            <v-list-item-subtitle>Activity</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider></v-divider>

      <v-list two-line>

        <v-list-item 
        @click=""
          v-for="activity in activitiesByDate"
          :key="activity._id"
        >
        <v-list-item-content>
            <v-list-item-title v-html="markdownify(activity.text)"></v-list-item-title>
            <v-list-item-subtitle v-html="activity.createdAt"></v-list-item-subtitle>
          </v-list-item-content>
          
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import marked from 'marked';
import { mapState, mapActions, mapGetters } from 'vuex';
import CreateCard from './CreateCard';

export default {
  name: 'board',
  data: () => ({
    board: {},
     drawer: null,
    validList: false,
    draggingCard: null,
    droppingList: null,
    list: {
      name: '',
      order: 0,
      archived: false
    },
    notEmptyRules: [(value) => !!value || ''],
  }),
  mounted(){
    this.getBoard(this.$route.params.id)
      .then(response => {
        this.board = response.data || response
        document.querySelector(".v-application--wrap").style.background = `url(${this.board.background})`
      })
    this.findLists({ 
          query: {
            boardId: this.$route.params.id
          } 
        }).then(response => {
        const lists = response.data || response;
    })
    this.findCards({ 
          query: {
            boardId: this.$route.params.id
          } 
        }).then(response => {
        const cards = response.data || response;
    })
     this.findActivities({ 
          query: {
            boardId: this.$route.params.id
          } 
        }).then(response => {
        const activities = response.data || response;
    })
  },
  methods:{
    ...mapActions('boards', { getBoard: 'get' } ),
    ...mapActions('lists', { findLists: 'find' } ),
     ...mapActions('cards', { findCards: 'find' } ),
    ...mapActions('activities', { findActivities: 'find' } ),
    
    async createList() {
      if(this.validList){
        const { Lists, Activities } =  this.$FeathersVuex.api;
        this.list.boardId = this.$route.params.id
        const list = new Lists(this.list);
        console.log(list)
        await list.save();
        this.list = {
          name: '',
          order: 0,
          archived: false
        }
        this.createActivity(`**${this.user.user.displayName}** created list **${list.name}**`);
      }
    
    },
    createActivity(text){
      const { Activities } =  this.$FeathersVuex.api;
      const activity = new Activities();
        activity.text = text;
        activity.boardId = this.$route.params.id;
        activity.save();
        console.log(this)
    },
    startDraggingCard(card){
      console.log('started dragging...', card)
      this.draggingCard = card;
    },
    setDroppingLists(event, list){
      this.droppingList = list;
      event.preventDefault();
    },
    async dropCard(){
      if(this.droppingList){
        if(this.draggingCard.listId !== this.droppingList._id){
          const fromList = this.lists.find(list => list._id === this.draggingCard.listId);
          const toList = this.lists.find(list => list._id === this.droppingList._id);
          this.draggingCard.listId = this.droppingList._id;
          await this.draggingCard.save();
          this.createActivity(`**${this.user.user.displayName}** moved **${this.draggingCard.title}** from **${fromList.name}** to **${toList.name}**`);
        }
       
      }
      this.droppingList = null;
      this.draggingCard = null;
    },
    markdownify(text) {
      return marked(text);
    },
     removeList(event, _id) {
        this.$FeathersVuex.api.Boards.store.dispatch('lists/remove',_id);
     
         console.log(_id)
      }

  },
  computed: {
    ...mapState('boards', { 
      loadingBoard: 'isGetPending' ,
      boardsError: 'errorOnGet'
      } ),
      ...mapState('auth', {user: 'payload'}),
       ...mapState('lists', { 
      loadingLists: 'isFindPending' ,
      creatingList: 'isCreatePending' ,
      listsError: 'errorOnFind'
      } ),
       ...mapState('cards', { 
      cardsError: 'errorOnFind'
      } ),
    ...mapGetters('lists', { findListsInStore: 'find' } ),
    ...mapGetters('cards', { findCardsInStore: 'find' } ),
    ...mapGetters('activities', { findActivitiesInStore: 'find' } ),
    activities () {
      return this.findActivitiesInStore({ 
        query: {
          boardId: this.$route.params.id
        } 
        }).data;
    },
    lists () {
      return this.findListsInStore({ 
        query: {
          boardId: this.$route.params.id
        } 
        }).data;
    },
    cards () {
      return this.findCardsInStore({ 
        query: {
          boardId: this.$route.params.id
        } 
        }).data;
    },
     cardsByListId () {
      return this.cards.reduce((byId, card) => {
        byId[card.listId] = byId[card.listId] || [];
        byId[card.listId].push(card);
        return byId;
      }, {})
    },
    activitiesByDate () {
      return this.activities.slice().reverse();
    },
  },
  components: {
    CreateCard
  }
};
</script>


<style>
i.fas.fa-times {
    position: absolute;
    right: 13px;
    font-weight: 600;
}
.v-navigation-drawer__content .v-list-item__title {
    white-space: initial;
    padding-bottom: 10px;
}
@media (min-width: 600px){
    .flex.sm3 {
      flex-basis: 25%;
      flex-grow: 0;
      max-width: 19%;
  }
}
.board-canvas {
    position: relative;
    overflow: hidden;
    flex-grow: 1;
    height: 100%;
}

.container.board-wrapper.container--fluid .layout.row {
    height: 100%;
    align-content: flex-start;
}
.list-wrapper {
    width: 272px;
    margin: 0 4px;
    height: 100%;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
    white-space: nowrap;
}
.list-wrapper .v-card {
    background-color: #ebecf0;
    border-radius: 3px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    max-height: 100%;
    position: relative;
    white-space: normal;
}
#board .headline.list-header {
    font-size: 16px !important;
}
.list-card {
    background-color: #fff !important;
    border-radius: 3px !important;
    box-shadow: 0 1px 0 rgba(9,30,66,.25) !important;
    cursor: pointer;
    display: block !important;
    margin-bottom: 8px;
    max-width: 300px !important;
    min-height: 20px;
    position: relative !important;
    text-decoration: none !important;
    z-index: 0;
    padding: 5px 5px;
}
html {
    height: 100%;
}
body {
    background-color: #f4f5f7;
    position: relative;
    z-index: 0;
    overflow: hidden;
}
.board-main-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    margin-right: 0;
    position: relative;
    transition: margin .1s ease-in;
}
#board {
    -webkit-user-select: none;
    user-select: none;
    white-space: nowrap;
    margin-bottom: 8px;
    overflow-x: auto;
    overflow-y: hidden;
    padding-bottom: 8px;
    top: 0;
    right: 0;
    height: 100%;
    bottom: 0;
    left: 0;
    margin-left: 10px;
}
.v-application--wrap {
    background-repeat: repeat !important;
    background-size: cover !important;
    background-position: center !important;
}
.container--fluid {
    max-width: 100%;
    height: 100%;
}
h2.board-title {
    font-size: 18px;
    background: hsla(338, 13%, 78%, 0.44);
    border-radius: 3px;
    padding: 7px 7px;
    color: #fff !important;
    font-weight: 700;
        text-shadow: 1px 1px 2px rgba(37, 32, 32, 0.37);
}
.flex.board-head {
    display: flex;
    justify-content: space-between;
    width: 98%;
    margin: auto;
    margin-bottom: 13px;
}
a.board-menu {
    background: hsla(0, 0%, 100%, 0.3);
    border-radius: 3px;
    padding: 7px 7px;
    color: #fff !important;
    font-size: 14px;
    font-weight: 700;
    height: 35px;
}
a.board-menu i.fas.fa-ellipsis-h {
    margin-right: 6px;
}
.list-card .v-card__title.headline {
    line-height: 1rem;
    font-size: 14px !important;
    padding: 5px 5px;
}
#board .v-card {
    background-color: #ebecf0;
}
#board .v-card .col.col-12 {
    padding: 0px 8px;
}
.v-card__title.board-title {
    background: #48581912;
    padding: 6px 15px;
        margin-bottom: 10px;
}
.create-list {
    width: 272px;
    margin: 0 4px;
    height: 100%;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
    white-space: nowrap;
}
#board .create-list form.v-form {
    padding: 8px;
}
.v-card__title.board-title .headline.board-title {
    font-size: 16px !important;
    color: #fff;
}
.create-list .v-card__title.board-title {
    background: #0c76ff;
}
#board .create-list form.v-form button {
    width: 100%;
    text-align: left;
}
#board .create-list form.v-form button span.v-btn__content {
    display: block;
}

</style>